import { Button, Paper, Typography } from '@mui/material';
import Image from '../Image/Image';

import stringUtils from '../../utils/StringUtils';

import './VectorFocus.scss';

function VectorFocus({vectorFocus, isOwnedByUser, handleGoToVectorFocusUpdate,
  handleClickDelete, handleClickShowOnMap}) {
  const vecforFocusImage = vectorFocus?.picture?.url;
  const description = vectorFocus?.description;
  const denounceStatusName = stringUtils.getPrettyDenounceStatus(vectorFocus?.denounce_status?.name);
  const diseaseVectorName = vectorFocus?.disease_vector?.name;
  const possibleFocusName = vectorFocus?.possible_focus?.name;
  const cityName = vectorFocus?.city?.name;
  const createdAt = stringUtils.getPrettyDateTime(vectorFocus?.created_at);
  const updatedAt = stringUtils.getPrettyDateTime(vectorFocus?.updated_at);
  const address = stringUtils.getPrettyAddress({ 
    city: vectorFocus?.city?.name,
    address: vectorFocus?.address
  });

  function handleDelete() {
    handleClickDelete?.(vectorFocus.id);
  }

  return (
    <Paper className="vector-focus-item" elevation={2}>
      {vecforFocusImage && (
        <div className="vector-focus-item-field image">
          <Image src={vecforFocusImage}/>
        </div>
      )}
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Endereço</Typography>
        <Typography variant="p" component="p">{address}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Geo localização</Typography>
        <Button onClick={handleClickShowOnMap}>Veja no mapa</Button>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Descrição</Typography>
        <Typography variant="p" component="p">{description}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Status</Typography>
        <Typography variant="p" component="p">{denounceStatusName}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Vetor</Typography>
        <Typography variant="p" component="p">{diseaseVectorName}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Tipo do foco</Typography>
        <Typography variant="p" component="p">{possibleFocusName}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Cidade</Typography>
        <Typography variant="p" component="p">{cityName}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Data de criação</Typography>
        <Typography variant="p" component="p">{createdAt}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label">Última atualização</Typography>
        <Typography variant="p" component="p">{updatedAt}</Typography>
      </div>
      {isOwnedByUser && (
        <div className="action-buttons">
          {handleGoToVectorFocusUpdate && <Button onClick={handleGoToVectorFocusUpdate}>Atualizar</Button>}
          {handleClickDelete && <Button onClick={handleDelete}>Deletar</Button>}
        </div>
      )}
    </Paper>
  );
}

export default VectorFocus;